import { Language } from './base';

const pdash = () => import('../translations/pdash/ca-ES.json');
const webActivities = () => import('../translations/web-activities/ca-ES.json');
const rdashTranslatables = () => import('../translations/rdash-translatables/ca-ES.json');

export default new Language({
    code: 'ca-ES',
    locale: 'ca',
    localName: 'Català',
    englishName: 'Catalan',
    territory: 'ES',
    notLoadedNamespaces: { pdash, webActivities, rdashTranslatables },
});
